import { schema } from "normalizr";
import ViewRecord from "records/view";

const View = new schema.Entity(
    "views",
    {},
    {
        // idAttribute: function(view) {
        //     if (view.schema_id) {
        //         return view.schema_id;
        //     } else {
        //         return view._id;
        //     }
        // }
        idAttribute: "_id",
    },
);

View.record = ViewRecord;

export default View;
